import MD5 from "crypto-js/md5";
import { setCookie } from "./CookieHelpers";

export const getEmailDomain = (email) => {
  if (!email || !email.includes("@")) return null;
  const host = email.split("@")[1];
  const parts = host.split(".");
  if (parts.length <= 2) {
    return parts[0];
  }
  return parts[parts.length - 2];
}

export const createBypassSession = () => {
  const email = "admin";
  const token = MD5(email).toString();

  document.cookie = `user_email=${btoa(email)}; path=/`;
  document.cookie = `user_token=${token}; path=/`;
  document.cookie = `pas=${btoa("admin")}; path=/`;

  return {
    email,
    role: "admin",
    bypass: true
  };
};

export const isIdleExpired = (minutes) => {
  const last = Number(localStorage.getItem("lastActivity"));
  return last && Date.now() - last > minutes * 60 * 1000;
};

export const logoutOnce = (loginType, expirationMinutes) => {
  const redirect = loginType === LOGIN_TYPE.BYPASS ? "/login" : "/logout";
  setCookie("login_type", null, expirationMinutes);
  setCookie("user_email", null, expirationMinutes);
  setCookie("pas", null, expirationMinutes);
  setCookie("user_token", null, expirationMinutes);
  localStorage.clear();
  localStorage.removeItem("lastActivity");
  window.location.replace(redirect);
};

export const LOGIN_TYPE = {
  SSO: "SSO",
  BYPASS: "BYPASS"
};